import React from 'react'
import Skeleton from 'react-loading-skeleton'

const TransitionCard = ({ count }) => {
  return (
    <div className="program-list">
      {Array(count)
        .fill(0)
        .map((_, index) => (
          <div key={index} className="program-item">
            <Skeleton className='program-image' />
            <div className="program-details w-75">
              <h3>
                <Skeleton width="40%" />
              </h3>
              <p>
                <Skeleton width="20%" />
              </p>
            </div>
            <p className='program-price w-25 text-end' >
              <Skeleton width='30%' />
            </p>

          </div>
        ))}
    </div>
  )
}

export default TransitionCard